$(document).ready(function() {
	if(!document.querySelector('.GPC0054')) return false;

	// LGEGMC-3505 Start
	function cutByLen(str, breakByte, lastIdx) {
		for(b=i=0;c=str.charCodeAt(i);) {
			b+=c>>7?2:1;
			// LGEAU-1027 Start
			if (b > breakByte && str.indexOf("<a") == -1) {
				break;
			} else if (b > breakByte && str.substring(0,i).slice(-4) == "</a>") {
				break;
			}
			// LGEAU-1027 End
			i++;
		}
		const breakText = {
			short: str.substring(0,i),
			over: str.substring(i,lastIdx)
		}
		return breakText;
	}

	const $obj = $('.GPC0054');
	$obj.each(function() {
		const $parent = $(this);
		const $target = $(this).find('.title-wrap .copy'),
			originTxt = $target.html(),
			btnMoreTxt = $target.data('more'),
			btnLessTxt = $target.data('less');

		if($target.length>0 && originTxt.length>300) {
			let textSlice = cutByLen(originTxt, 300, originTxt.length);
			const btnMore = '<span class="over-button over-more">... <a href="#" role="button" class="more">'+btnMoreTxt+'</a></span>';
			const btnLess = '<span class="over-button over-less d-none"> <a href="#" role="button" class="less">'+btnLessTxt+'</a></span>';

			const text = 
				'<span>' + textSlice.short + '</span>' +
				'<span class="over-text d-none">' + textSlice.over + '</span>' +
				btnMore + btnLess;

			$target.html(text);
		}
	});

	$('.GPC0054').on('click', '.over-button a', function(e) {
		e.preventDefault();

		const targetClass = $(this).attr('class');
		let REMOVE_NONE_CLASS, ADD_NONE_CLASS, FOCUS_CLASS;

		if(targetClass === 'more'){
			REMOVE_NONE_CLASS = '.over-text, .over-less';
			ADD_NONE_CLASS = '.over-more';
			FOCUS_CLASS = '.less';
		}else if(targetClass === 'less'){
			REMOVE_NONE_CLASS = '.over-more';
			ADD_NONE_CLASS = '.over-text, .over-less';
			FOCUS_CLASS = '.more';
		}

		$(this).closest('.copy')
			.find(REMOVE_NONE_CLASS).removeClass('d-none').end()
			.find(ADD_NONE_CLASS).addClass('d-none').end()
			.find(FOCUS_CLASS).focus();
	});
	// LGEGMC-3505 End
});